import { createContext, useContext, type ReactNode } from 'react'

import type { User } from '@state/user'

export interface DesktopNavigationContextValue {
  isExpanded: boolean
  setExpanded: (expanded: boolean) => void
  isActive: (path: string) => boolean
  storeId: string
  scanId: string | undefined
  user: User
}

const DesktopNavigationContext = createContext<DesktopNavigationContextValue | undefined>(undefined)

// eslint-disable-next-line react-refresh/only-export-components
export function useDesktopNavigation() {
  const context = useContext(DesktopNavigationContext)
  if (!context) {
    throw new Error('useDesktopNavigation must be used within a DesktopNavigationProvider')
  }
  return context
}

interface DesktopNavigationProviderProps {
  value: DesktopNavigationContextValue
  children: ReactNode
}

export function DesktopNavigationProvider({ value, children }: DesktopNavigationProviderProps) {
  return (
    <DesktopNavigationContext.Provider value={value}>
      {children}
    </DesktopNavigationContext.Provider>
  )
}

